












import { Component, Mixins } from 'vue-property-decorator';
import AddEditForm from './components/add-edit-form.vue';
import { GANG_STOP_PERSON } from '../router-names';
import GoBackWithCloseTabMixin from '@root/common/mixins/go-back-with-close-tab';
// axios请求
import { editInfoSentry } from '@/api/parking-lot-management/index';

@Component({
  components: { AddEditForm }
})
export default class GangStopEdit extends Mixins(GoBackWithCloseTabMixin) {
  path = '/smart-parking/parking-lot-management/gang-stop-person';

  headTitle = '编辑岗亭账号'; // 标题
  formData = {};
  id = '';
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '岗亭账号信息',
        location: {
          name: GANG_STOP_PERSON
        }
      },
      {
        label: this.headTitle
      }
    ];
  }

  created() {
    this.id = this.$route.params.id;
    console.log(this.id);
    this.queryeditInfoSentry();
  }
  async queryeditInfoSentry() {
    try {
      const { status, msg, data, code } = await editInfoSentry({ id: this.id });
      console.log(status, msg, data, code);
      this.formData = { ...data, enabled: data.enabled === '01', passwordTwo: data.password };
    } catch (e) {
      console.log(e);
    }
  }
  isSubmitOk() {
    this.goBack();
  }
}
